/* eslint-disable array-callback-return */
/*****components***/
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import decode from "jwt-decode";
import {
  find,
  findValueById,
  callApi,
  setCookie,
  getCookie,
} from "../../common/functions";
import { getS3PublicFile } from "../../common/functionsV2";
import PageLoading from "../../components/PageLoading";

class page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reridrect: false,
      goHome: false,
      isLoading: true,
    };
  }

  /*loading data*/
  componentDidMount = async () => {
    try {
      let token = this.props.match.params.token;
      console.log(token);
      let resp = await callApi("frontend", "getUserInfoByCartID", {
        id: token,
      });
      console.log("resp:::", resp);
      let storeid = resp.storeid;

      const respStores = await getS3PublicFile(
        process.env.REACT_APP_S3FILES + `/public/files/tiendas.json`
      );
      let stores = [];

      respStores
        .filter(key => key.online_status === 1)
        .sort((a, b) => a.sort_order - b.sort_order)
        .map(function (key) {
          let store = {
            storeId: key.storeId,
            storeName: key.storeName,
            catalogId: key.catalogId,
            lat: key.lat,
            lng: key.lng,
            add: key.address,
          };
          stores.push(store);
        });

      let catalogId = findValueById(stores, storeid, "storeId", "catalogId");

      console.log(catalogId, storeid, resp.storeid);
      if (
        resp.success &&
        catalogId > 0 &&
        storeid.toString() === resp.storeid.toString()
      ) {
        //console.log("res", resp)

        //let tempCart = localStorage.getItem(process.env.REACT_APP_ORG_NAME+'_activeCartV3')
        //var curCart=JSON.parse(tempCart)

        var dataC = [];
        try {
          dataC = JSON.parse(
            getCookie(process.env.REACT_APP_ORG_NAME + "_cartSessionsV3")
          );
          if (dataC) {
            let pos = find(dataC, storeid, "storeid");
            if (pos > 0) {
              console.log("actualizamos");
              dataC[pos] = {
                id: token,
                storeid: resp.storeid,
                userid: resp.userId,
              };
            } else {
              console.log("llenamos");
              dataC.push({
                id: token,
                storeid: resp.storeid,
                userid: resp.userId,
              });
            }
          } else {
            dataC = [{ id: token, storeid: resp.storeid, userid: resp.userId }];
          }
        } catch (Ex) {
          console.log("empty cart");
          dataC = [{ id: token, storeid: resp.storeid, userid: resp.userId }];
        }

        //console.log("dataC", dataC)

        localStorage.setItem(
          process.env.REACT_APP_ORG_NAME + "_activeCartV3",
          JSON.stringify(resp.shopCart)
        );
        setCookie(
          process.env.REACT_APP_ORG_NAME + "_cartSessionsV3",
          JSON.stringify(dataC),
          24
        );

        var data = {
          userId: resp.userId,
          userToken: resp.token,
        };

        var tData = decode(resp.token);

        var haveEvent = tData.haveenvent;
        if (haveEvent > 0) {
          localStorage.setItem(
            process.env.REACT_APP_ORG_NAME + "_haveEvent",
            haveEvent
          );
        }

        setCookie(
          process.env.REACT_APP_ORG_NAME + "_userloginV3",
          JSON.stringify(data),
          168 //24
        );
        ///localStorage.removeItem(process.env.REACT_APP_ORG_NAME + "_userloginV2");

        data = {
          userId: resp.userId,
          token: tData,
          keyToken: resp.token,
        };

        await this.props.updateUserInfo(data);
        await this.props.updateCart(resp.shopCart);

        setTimeout(
          async function () {
            this.setState({ reridrect: true, isLoading: false });
          }.bind(this),
          1500
        );
      } else {
        this.setState({ goHome: true, isLoading: false });
        console.log("invalid data");
      }
    } catch (Ex) {
      this.setState({ goHome: true, reridrect: false, isLoading: false });
    }
  };

  render() {
    return (
      <div className="page-wrapper" onClick={this.props.hideCart}>
        <div className="content container-page custom-container container-fluid">
          <div
            className="row mt-20"
            style={{ height: 350, display: "flex", alignItems: "center" }}
          >
            <div className="col-12 col-12 text-center">
              <PageLoading isLoading={this.state.isLoading} />

              {this.state.reridrect && (
                <Redirect to={{ pathname: "/checkout/cart" }} />
              )}

              {this.state.goHome && <Redirect to={{ pathname: "/" }} />}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default page;
